module.exports = __webpack_public_path__ + "media/B_L4.d53b9825.mp3";